import axios from "axios";
import moment from "moment";
import { getCachedData, setCachedData } from "./apiCache";

const DEFAULT_SCHOOL_START = "07:30";
const TIMINGS_CACHE_KEY = "school_timings";

/**
 * Fetch the school timetable timings (shift start/end per season).
 * Cached so the dashboard and attendance page share one request.
 */
export const fetchSchoolTimings = async (authtoken) => {
  const cached = getCachedData(TIMINGS_CACHE_KEY);
  if (cached) return cached;
  try {
    const response = await axios.get("https://api.mirai.healthcare/api/timetable/manageschooltime", {
      headers: { "x-auth": authtoken },
    });
    const data = Array.isArray(response?.data) ? response.data : response?.data?.data || [];
    const timings = data.filter((t) => t.is_active && !t.is_deleted && t.shift_start_time);
    setCachedData(TIMINGS_CACHE_KEY, timings);
    return timings;
  } catch (error) {
    console.error("Error fetching school timings:", error);
    return [];
  }
};

/**
 * School start time ("HH:mm") for a date: the active timing whose date range covers it,
 * preferring the given session. Falls back to 07:30.
 */
export const getSchoolStartTime = (timings, date, sessionId) => {
  const day = moment(date);
  const inRange = (timings || []).filter(
    (t) => !day.isBefore(moment(t.start_date), "day") && !day.isAfter(moment(t.end_date), "day")
  );
  const timing =
    inRange.find((t) => String(t.session) === String(sessionId)) || inRange[0] || (timings || [])[0];
  return timing?.shift_start_time || DEFAULT_SCHOOL_START;
};

const toMinutes = (time, formats) => {
  const t = moment(time, formats);
  return t.isValid() ? t.hours() * 60 + t.minutes() : null;
};

/**
 * Late = marked present with an in time after school start. Returns the in time
 * formatted "hh:mm A" when late, otherwise null.
 */
export const getLateInTime = (record, timings, sessionId) => {
  if (!record?.in_time || String(record.status || "").toLowerCase() !== "present") return null;
  const inMinutes = toMinutes(record.in_time, ["hh:mm A", "h:mm A", "HH:mm:ss", "HH:mm"]);
  const startMinutes = toMinutes(getSchoolStartTime(timings, record.date, sessionId), "HH:mm");
  if (inMinutes === null || startMinutes === null || inMinutes <= startMinutes) return null;
  return moment(record.in_time, ["hh:mm A", "h:mm A", "HH:mm:ss", "HH:mm"]).format("hh:mm A");
};
